import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface NewsPost {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt: string | null;
  image_url: string | null;
  additional_images: string[];
  published_at: string;
  created_at: string;
}

export function useNewsPosts(limit?: number) {
  return useQuery({
    queryKey: ['news-posts', limit],
    queryFn: async (): Promise<NewsPost[]> => {
      let query = supabase
        .from('news_posts')
        .select('*')
        .order('published_at', { ascending: false });
      
      if (limit) {
        query = query.limit(limit);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching news posts:', error);
        throw error;
      }

      return data || [];
    },
  });
}

export function useNewsPost(slug: string) {
  return useQuery({
    queryKey: ['news-post', slug],
    queryFn: async (): Promise<NewsPost | null> => {
      const { data, error } = await supabase
        .from('news_posts')
        .select('*')
        .eq('slug', slug)
        .maybeSingle();

      if (error) {
        console.error('Error fetching news post:', error);
        throw error;
      }

      return data;
    },
    enabled: !!slug,
  });
}
